import { Typography } from "@mui/material";
import {
  Datagrid,
  DateField,
  downloadCSV,
  List,
  TextField,
  TopToolbar,
  useListContext,
  usePermissions,
  useRecordContext,
  useRefresh,
} from "react-admin"; // eslint-disable-line import/no-unresolved
import ApplicationLinkApplicationIdField from "../applications/ApplicationLinkApplicationIdField";
import CustomerIdLinkUserIdField from "../customers/CustomerIdLinkUserIdField";
import LoanNumLinkField from "../loans/LoanNumLinkField";
import CustomAmountField from "../unit/CustomAmountField";
import CustomCancelTaskIcon from "../unit/CustomCancelTaskIcon";
import CustomDateField from "../unit/CustomDateField";
import CustomExportButton from "../unit/CustomExportButton";
import CustomFilterButton from "../unit/CustomFilterButton";
import PostPagination from "../unit/PostPagination";
import useNotify from "../unit/useNotify";
import AchPaymentsAside from "./AchPaymentsAside";
import AchPaymentsFilters from "./AchPaymentsFilters";
import { hmLightTheme } from "../themes/hmTheme";
import formatDate from "../unit/formatDate";
import HmLoading from "../unit/HmLoading";
import NoResults from "../unit/NoResults";
const AchPaymentsListActions = () => {
  const { total } = useListContext();
  const { permissions } = usePermissions();
  const listContext = useListContext();
  const { filterValues } = listContext;

  return (
    <TopToolbar sx={{ width: "100%" }}>
      <CustomFilterButton />
      <CustomExportButton />
    </TopToolbar>
  );
};
const CustomErrorMsg = () => {
  const record = useRecordContext();
  if (!record) return null;
  let errormsg = record?.sErrorMsg;
  if (errormsg == "No Source FundingSource Found.") {
    errormsg = "No Funding Source";
  }
  return <Typography>{errormsg}</Typography>;
};
const CustomAccountNumberLast4NumberField = ({
  source,
  label,
  ...props
}: any) => {
  const record = useRecordContext();
  if (!record) return null;
  const accountNumber = record[source];
  if (accountNumber && accountNumber.length >= 4) {
    return (
      <Typography
        title={accountNumber} // Show full account number on hover
      >
        ***{accountNumber.slice(-4)} {/* Display only the last 4 digits */}
      </Typography>
    );
  }
  return <Typography>***{accountNumber ? accountNumber : ""}</Typography>;
};

const total: any = [];

const AchPaymentsList = () => (
  <List
    actions={<AchPaymentsListActions />}
    // filters={AchPaymentsFilters}
    // sort={{ field: "id", order: "DESC" }}
    aside={<AchPaymentsAside totalData={total} />}
    // exporter={customACHExporter}
    pagination={<PostPagination />}
    perPage={25}
    sx={{
      width: "100%",
      borderRadius: "0px",
      "& .MuiCard-root": {
        borderRadius: "0px",
      },
    }}
    empty={
      <Typography className="no-results">
        <NoResults />
      </Typography>
    }
    emptyWhileLoading={false}
    loading={<HmLoading />}
  >
    <DefaultList />
    {/* <ShowListTotal /> */}
  </List>
);
const CustomCompletedField = ({ ...props }) => {
  const record = useRecordContext();
  if (!record) return null;
  if (record.dCompletedDate) {
    return <DateField source="dCompletedDate" />;
  } else {
    return (
      <Typography color="error">
        {record.sErrorMsg ? record.sErrorMsg : "No Completed Date"}
      </Typography>
    );
  }
};

const DefaultList = ({ ...props }) => {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const listContext = useListContext();
  const { filterValues } = listContext;
  const { total, data, isPending, isLoading, isFetching } = useListContext();

  let IdTitle = "Transfer #";
  if (
    filterValues.status &&
    filterValues.status.includes("Repayment - Scheduled (5Days)")
  ) {
    IdTitle = "Payment #";
  }

  const CancelTaskAction = ({ ...props }) => {
    const record = useRecordContext();
    if (!record) return null;
    const refresh = useRefresh();

    return (
      <CustomCancelTaskIcon
        type={record?.sType}
        id={record?.id}
        onClick={refresh}
      />
    );
  };
  return (
    <>
      <Datagrid
        rowClick={false}
        optimized
        id="table-achpayments"
        className="hm-list-datagrid"
        sx={{
          ".MuiTableCell-root": {
            // padding:"6px 16px"
            padding: "6px",
          },
          ".RaDatagrid-headerCell:first-child": {
            borderTopLeftRadius: "0px",
          },
          ".RaDatagrid-headerCell:last-child": {
            borderTopRightRadius: "0px",
          },
          "& .column-groups": {
            md: { display: "none" },
            lg: { display: "table-cell" },
          },
          "& .Mui-active": {
            color: "gray",
          },
          "& .MuiTableSortLabel-root": {
            padding: "5px",
          },
          "& .RaDatagrid-headerCell": {
            color: "gray",
            fontSize: "1rem",
            backgroundColor: "#edf4fb",
            wordWrap: "break-word",
            whiteSpace: "pre-line",
          },
          "& .MuiTableCell-paddingCheckbox": {
            display: "none",
          },
          "& .MuiTableCell-root.column-id": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
          },
          "& .MuiTableCell-root.column-sErrorMsg": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
          },
          "& .MuiTableCell-root.column-dCreatedDate": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
          },
          "& .MuiTableCell-root.column-scheduled": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
          },
          "& .MuiTableCell-root.column-dSubmittedDate": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
          },
          "& .MuiTableCell-root.column-dCompletedDate": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
          },
          "& .MuiTableCell-root.column-dErrorDate": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
          },
          "& .MuiTableCell-root.column-dAmount": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
          },
          "& .MuiTableCell-root.column-iApplicationId": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAppIdWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdAppIdWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAppIdWidth,
          },
          "& .MuiTableCell-root.column-sLoanNum": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdLoanIdWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdLoanIdWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdLoanIdWidth,
          },
          "& .MuiTableCell-root.column-iUserId": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdUserIdWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdUserIdWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdUserIdWidth,
          },

          "& .MuiTableCell-root.column-sendbank": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
          },
          "& .MuiTableCell-root.column-sendaccount": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
          },
          "& .MuiTableCell-root.column-receivingbank": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
          },
          "& .MuiTableCell-root.column-receivingaccount": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
          },
          "& .MuiTableCell-root.column-sOwner": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
          },
        }}
        //   bulkActionButtons={<BankerBulkActions />}
      >
        {filterValues.status && filterValues.status.includes("Today") ? (
          <TextField
            source="iSourceId"
            label={IdTitle}
            sortBy={"iSourceId"}
            cellClassName="numericText"
          />
        ) : (
          <TextField
            source="id"
            label={IdTitle}
            // sortBy={"id"}
            cellClassName="numericText"
          />
        )}
        {/* <NumberField source="dAmount" label="Amount" /> */}
        <CustomAmountField
          source="dAmount"
          label="Amount"
          sortBy={"amount"}
          cellClassName="amountText"
        />
        {filterValues.status != "Refill - Processing" &&
          filterValues.status != "Refill - Today" &&
          filterValues.status != "Refill - Processed (30Days)" &&
          filterValues.status != "Refill - Failed (30Days)" &&
          filterValues.status != "Refill - Scheduled (5Days)" && (
            <ApplicationLinkApplicationIdField
              source="iApplicationId"
              label="App #"
              sortBy={"iApplicationId"}
              // sortable={false}
            />
          )}
        {filterValues.status != "Refill - Processing" &&
          filterValues.status != "Refill - Today" &&
          filterValues.status != "Refill - Processed (30Days)" &&
          filterValues.status != "Refill - Failed (30Days)" &&
          filterValues.status != "Refill - Scheduled (5Days)" && (
            <LoanNumLinkField
              source="sLoanNum"
              label="Loan #"
              sortBy="sLoanNum"
              // sortable={false}
            />
          )}
        {filterValues.status != "Refill - Processing" &&
          filterValues.status != "Refill - Today" &&
          filterValues.status != "Refill - Processed (30Days)" &&
          filterValues.status != "Refill - Failed (30Days)" &&
          filterValues.status != "Refill - Scheduled (5Days)" && (
            <CustomerIdLinkUserIdField
              source="iUserId"
              label="User #"
              sortBy={"iUserId"}
              // sortable={true}
            />
          )}
        {/* <TextField
          source="sendbank"
          label={`Sending\r\nBank`}
          sortBy="sendingbank"
          sortable={false}
        />
        <CustomAccountNumberLast4NumberField
          source="sendaccount"
          label={`Sending\r\nAccount`}
          sortBy={"sendaccount"}
          sortable={false}
          cellClassName="numericText"
        />
        <TextField
          source="receivingbank"
          label={`Receiving\r\nBank`}
          sortBy={"receivingbank"}
          sortable={false}
        />
        <CustomAccountNumberLast4NumberField
          source="receivingaccount"
          label={`Receiving\r\nAccount`}
          sortBy={"receivingaccount"}
          sortable={false}
          cellClassName="numericText"
        /> */}
        <TextField
          source="sOwner"
          label="Method"
          sortable={false}
          cellClassName="textText"
        />
        {filterValues.status && (
          <CustomDateField
            source="scheduled"
            label="Date Scheduled"
            onlyShowDate={true}
            sortBy={"scheduled"}
            sortable={false}
            cellClassName="dateText"
          />
        )}
        {filterValues.status && filterValues.status.includes("120-Day") && (
          <TextField source="sType" label="Type" sortable={false} />
        )}
        {/* //have filterValues.status have processing ,show Date Submitted  */}
        {filterValues.status && filterValues.status.includes("Refill") && (
          <CustomDateField
            source="dCreatedDate"
            // label="Date Submitted"
            label="Date Initiated"
            onlyShowDate={true}
            sortBy={"submitted"}
            // sortable={false}
            cellClassName="dateText"
          />
        )}
        {filterValues.status &&
          !filterValues.status.includes("Refill") &&
          !filterValues.status.includes("Schedule") && (
            <CustomDateField
              source="dSubmittedDate"
              // label="Date Submitted"
              label="Date Initiated"
              onlyShowDate={true}
              sortBy={"submitted"}
              // sortable={false}
              cellClassName="dateText"
            />
          )}
        {filterValues.status && filterValues.status.includes("Processed") && (
          <CustomDateField
            source="dCompletedDate"
            label="Date Completed"
            onlyShowDate={true}
            sortBy={"dCompletedDate"}
            sortable={false}
            cellClassName="dateText"
          />
        )}
        {filterValues.status &&
          (filterValues.status.includes("Failed") ||
            filterValues.status.includes("Unable to Initiate") ||
            filterValues.status.includes("120-Day")) && (
            <CustomErrorMsg
              source="sErrorMsg"
              label="Error Code"
              sortable={false}
            />
          )}

        {filterValues.status &&
          (filterValues.status.includes("Failed") ||
            filterValues.status.includes("Unable to Initiate") ||
            filterValues.status.includes("120-Day")) && (
            <CustomDateField
              source="dErrorDate"
              label="Date Failed"
              onlyShowDate={true}
              sortBy={false}
              sortable={false}
              cellClassName="dateText"
            />
          )}

        {filterValues.status &&
          filterValues.status.includes("Repayment") &&
          filterValues.status.includes("Processed") && (
            <TextField source="sOwner" label="Method" sortable={false} />
          )}

        {filterValues.status && filterValues?.status.includes("Today") && (
          <CancelTaskAction lable="Action" source="action" sortable={false} />
        )}
      </Datagrid>
    </>
  );
};
export default AchPaymentsList;
